<div [ngStyle]="mapDivStyle()">
<div class='lgr_col'>
  <div class='lgr_10 col_01'><dynamic-field [id]='"scrndat"' [size]=10 [line]=1 [column]=1 [(ngModel)]='scrndat'></dynamic-field></div>
  <div class='lgr_08 col_12'><dynamic-field [id]='"scrntim"' [size]=8 [line]=1 [column]=12 [(ngModel)]='scrntim'></dynamic-field></div>
  <div class='lgr_29 col_26'><span class='brt high default' id='text1'>NRPC - STARS - TICKET INQUIRY</span>  </div>
  <div class='lgr_05 col_74'><span class='brt high default' id='text2'>S125G</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_06 col_01'><span class='brt high default' id='text3'>SERIES</span>  </div>
  <div class='lgr_12 col_08'><dynamic-field [id]='"series"' [size]=12 [line]=2 [column]=8 [(ngModel)]='series'></dynamic-field></div>
  <div class='lgr_20 col_30'><span class='brt high default' id='text4'>ISSUANCE INFORMATION</span>  </div>
  <div class='lgr_20 col_59'><dynamic-field [id]='"revnbr"' [size]=20 [line]=2 [column]=59 [(ngModel)]='revnbr'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_04 col_01'><span class='brt high default' id='text5'>PNR#</span>  </div>
  <div class='lgr_06 col_06'><dynamic-field [id]='"pnrnbr"' [size]=6 [line]=3 [column]=6 [(ngModel)]='pnrnbr'></dynamic-field></div>
  <div class='lgr_07 col_14'><span class='brt high default' id='text6'>CR-DATE</span>  </div>
  <div class='lgr_08 col_22'><dynamic-field [id]='"pnrcrdt"' [size]=8 [line]=3 [column]=22 [(ngModel)]='pnrcrdt'></dynamic-field></div>
  <div class='lgr_09 col_32'><span class='brt high default' id='text7'>ACTV TYPE</span>  </div>
  <div class='lgr_16 col_42'><dynamic-field [id]='"actvtyp"' [size]=16 [line]=3 [column]=42 [(ngModel)]='actvtyp'></dynamic-field></div>
  <div class='lgr_03 col_60'><span class='brt high default' id='text8'>DMY</span>  </div>
  <div class='lgr_01 col_64'><dynamic-field [id]='"dmyind"' [size]=1 [line]=3 [column]=64 [(ngModel)]='dmyind'></dynamic-field></div>
  <div class='lgr_08 col_67'><span class='brt high default' id='text9'>TXN TYPE</span>  </div>
  <div class='lgr_01 col_76'><dynamic-field [id]='"txntyp"' [size]=1 [line]=3 [column]=76 [(ngModel)]='txntyp'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_03 col_01'><span class='brt high default' id='text10'>AGT</span>  </div>
  <div class='lgr_04 col_05'><dynamic-field [id]='"pnragnt"' [size]=4 [line]=4 [column]=5 [(ngModel)]='pnragnt'></dynamic-field></div>
  <div class='lgr_03 col_11'><span class='brt high default' id='text11'>LOC</span>  </div>
  <div class='lgr_03 col_15'><dynamic-field [id]='"pnrloc"' [size]=3 [line]=4 [column]=15 [(ngModel)]='pnrloc'></dynamic-field></div>
  <div class='lgr_06 col_20'><span class='brt high default' id='text12'>OUTLET</span>  </div>
  <div class='lgr_03 col_27'><dynamic-field [id]='"pnrout"' [size]=3 [line]=4 [column]=27 [(ngModel)]='pnrout'></dynamic-field></div>
  <div class='lgr_12 col_42'><dynamic-field [id]='"spolmsg"' [size]=12 [line]=4 [column]=42 [(ngModel)]='spolmsg'></dynamic-field></div>
  <div class='lgr_10 col_60'><span class='brt high default' id='text13'>TKT OUTLET</span>  </div>
  <div class='lgr_03 col_71'><dynamic-field [id]='"outlet"' [size]=3 [line]=4 [column]=71 [(ngModel)]='outlet'></dynamic-field></div>
  <div class='lgr_01 col_76'><dynamic-field [id]='"altdel"' [size]=1 [line]=4 [column]=76 [(ngModel)]='altdel'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_09 col_01'><span class='brt high default' id='text14'>PSGR NAME</span>  </div>
  <div class='lgr_19 col_11'><dynamic-field [id]='"psgrnm"' [size]=19 [line]=5 [column]=11 [(ngModel)]='psgrnm'></dynamic-field></div>
  <div class='lgr_06 col_35'><span class='brt high default' id='text15'>PRICED</span>  </div>
  <div class='lgr_16 col_42'><dynamic-field [id]='"priced"' [size]=16 [line]=5 [column]=42 [(ngModel)]='priced'></dynamic-field></div>
  <div class='lgr_10 col_60'><span class='brt high default' id='text16'>ALLOC METH</span>  </div>
  <div class='lgr_08 col_71'><dynamic-field [id]='"alocmth"' [size]=8 [line]=5 [column]=71 [(ngModel)]='alocmth'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_07 col_01'><span class='brt high default' id='text17'>ISS DT:</span>  </div>
  <div class='lgr_08 col_09'><dynamic-field [id]='"issuedt"' [size]=8 [line]=6 [column]=9 [(ngModel)]='issuedt'></dynamic-field></div>
  <div class='lgr_09 col_18'><span class='brt high default' id='text18'>TKT AGNT:</span>  </div>
  <div class='lgr_09 col_28'><dynamic-field [id]='"agent"' [size]=9 [line]=6 [column]=28 [(ngModel)]='agent'></dynamic-field></div>
  <div class='lgr_04 col_38'><span class='brt high default' id='text19'>AAA:</span>  </div>
  <div class='lgr_03 col_43'><dynamic-field [id]='"aaa"' [size]=3 [line]=6 [column]=43 [(ngModel)]='aaa'></dynamic-field></div>
  <div class='lgr_04 col_47'><span class='brt high default' id='text20'>PRT:</span>  </div>
  <div class='lgr_04 col_52'><dynamic-field [id]='"prntrid"' [size]=4 [line]=6 [column]=52 [(ngModel)]='prntrid'></dynamic-field></div>
  <div class='lgr_04 col_57'><span class='brt high default' id='text21'>GDS:</span>  </div>
  <div class='lgr_02 col_62'><dynamic-field [id]='"gds"' [size]=2 [line]=6 [column]=62 [(ngModel)]='gds'></dynamic-field></div>
  <div class='lgr_04 col_65'><span class='brt high default' id='text22'>PLT:</span>  </div>
  <div class='lgr_03 col_70'><dynamic-field [id]='"pltcarr"' [size]=3 [line]=6 [column]=70 [(ngModel)]='pltcarr'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_05 col_05'><span class='brt high default' id='text23'>TOTAL</span>  </div>
  <div class='lgr_45 col_15'><dynamic-field [id]='"monhdgs"' [size]=45 [line]=7 [column]=15 [(ngModel)]='monhdgs'></dynamic-field></div>
  <div class='lgr_07 col_71'><dynamic-field [id]='"hotmsg"' [size]=7 [line]=7 [column]=71 [(ngModel)]='hotmsg'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_09 col_01'><dynamic-field [id]='"montotl"' [size]=9 [line]=8 [column]=1 [(ngModel)]='montotl'></dynamic-field></div>
  <div class='lgr_50 col_11'><dynamic-field [id]='"mondetl"' [size]=50 [line]=8 [column]=11 [(ngModel)]='mondetl'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_31 col_01'><span class='default' id='text24'>FOP PC    AMOUNT DEPENDENT DATA</span>  </div>
  <div class='lgr_39 col_40'><dynamic-field [id]='"stdttl"' [size]=39 [line]=9 [column]=40 [(ngModel)]='stdttl'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"fopln1"' [size]=79 [line]=10 [column]=1 [(ngModel)]='fopln1'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"fopln2"' [size]=79 [line]=11 [column]=1 [(ngModel)]='fopln2'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"fopln3"' [size]=79 [line]=12 [column]=1 [(ngModel)]='fopln3'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"fopln4"' [size]=79 [line]=13 [column]=1 [(ngModel)]='fopln4'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"fopln5"' [size]=79 [line]=14 [column]=1 [(ngModel)]='fopln5'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"fopln6"' [size]=79 [line]=15 [column]=1 [(ngModel)]='fopln6'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"fopln7"' [size]=79 [line]=16 [column]=1 [(ngModel)]='fopln7'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"fopln8"' [size]=79 [line]=17 [column]=1 [(ngModel)]='fopln8'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"fopln9"' [size]=79 [line]=18 [column]=1 [(ngModel)]='fopln9'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"fopln10"' [size]=79 [line]=19 [column]=1 [(ngModel)]='fopln10'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"fopln11"' [size]=79 [line]=20 [column]=1 [(ngModel)]='fopln11'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"fopln12"' [size]=79 [line]=21 [column]=1 [(ngModel)]='fopln12'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"msgln"' [size]=79 [line]=22 [column]=1 [(ngModel)]='msgln'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_03 col_07'><span class='brt high default' id='text25'>PF:</span>  </div>
  <div class='lgr_06 col_13'><span class='brt high default' id='text26'>4-EXIT</span>  </div>
  <div class='lgr_06 col_20'><span class='brt high default' id='text27'>3-MAIN</span>  </div>
  <div class='lgr_05 col_27'><dynamic-field [id]='"selmen"' [size]=5 [line]=23 [column]=27 [(ngModel)]='selmen'></dynamic-field></div>
  <div class='lgr_06 col_39'><dynamic-field [id]='"prev"' [size]=6 [line]=23 [column]=39 [(ngModel)]='prev'></dynamic-field></div>
  <div class='lgr_06 col_46'><dynamic-field [id]='"next"' [size]=6 [line]=23 [column]=46 [(ngModel)]='next'></dynamic-field></div>
  <div class='lgr_08 col_53'><span class='brt high default' id='text28'>9-COUPON</span>  </div>
  <div class='lgr_08 col_71'><dynamic-field [id]='"prnt"' [size]=8 [line]=23 [column]=71 [(ngModel)]='prnt'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_09 col_01'><span class='brt high default' id='text29'>SHIFT PF:</span>  </div>
  <div class='lgr_12 col_11'><dynamic-field [id]='"currc1"' [size]=12 [line]=24 [column]=11 [(ngModel)]='currc1'></dynamic-field></div>
  <div class='lgr_17 col_25'><dynamic-field [id]='"prevc1"' [size]=17 [line]=24 [column]=25 [(ngModel)]='prevc1'></dynamic-field></div>
  <div class='lgr_09 col_44'><dynamic-field [id]='"paymt"' [size]=9 [line]=24 [column]=44 [(ngModel)]='paymt'></dynamic-field></div>
  <div class='lgr_08 col_55'><dynamic-field [id]='"last"' [size]=8 [line]=24 [column]=55 [(ngModel)]='last'></dynamic-field></div>
  <div class='lgr_09 col_65'><dynamic-field [id]='"first"' [size]=9 [line]=24 [column]=65 [(ngModel)]='first'></dynamic-field></div>
</div>
</div>
